<template>
  <v-card>
    <v-card-title>
      User Search Statistics
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="userSearches" :search="search">
      <template v-slot:items="props">
        <td>{{ props.item.search_text }}</td>
        <td class="text-xs-left">{{ props.item.result_count }}</td>
        <td class="text-xs-left">{{ props.item.search_count }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "Search Text", value: "search_text" },
        { text: "Result Count", value: "result_count" },
        { text: "Search Count", value: "search_count" }
      ]
     };
  },
  computed: {
    userSearches() {
      return this.$store.state.userSearches;
    }
  },
  mounted() {
    this.$store.dispatch("fetchUserSearches");
  }
};
</script>
